module.exports = __webpack_public_path__ + "images/home/cupFiole.5dd5e01a.svg";